import { render, staticRenderFns } from "./nutritionShoppinList.vue?vue&type=template&id=1ff69674&scoped=true"
import script from "./nutritionShoppinList.vue?vue&type=script&lang=js"
export * from "./nutritionShoppinList.vue?vue&type=script&lang=js"
import style0 from "./nutritionShoppinList.vue?vue&type=style&index=0&id=1ff69674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff69674",
  null
  
)

export default component.exports